import React from 'react';
import {Link} from "react-router-dom";
import Themes from '../themes/Themes';
import "./TopMenu.scss";

function TopMenu() {
    const contactForm = "6e535727-ffeb-41dd-aa32-d10483a323be";

    return (
        <div className="top-menu">
            <Themes/>
            {/* <a className={'top-menu-icon'} target="_blank" href="https://discord.com"><div className="discord"></div></a> */}
            <Link to={{
                pathname: `/`
            }}>
                Scripts
            </Link>
            <a href="https://www.youtube.com/@SeikoGT_" target="_blank">
                Subscribe
            </a>
            <Link to={{
                pathname: `/info`
            }}>
                Info
            </Link>
            {contactForm ? <Link to={{pathname: `/contact`}}>Contact</Link> : null}
        </div>
    );
}

export default TopMenu;
